module.exports = __webpack_public_path__ + "img/Butterfly_00150.03247582.png";